import ArticleIcon from '@mui/icons-material/Article';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ClearIcon from '@mui/icons-material/Clear';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoOutlinedIcon from '@mui/icons-material/Info';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import {
  Alert,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import Rating from '@mui/material/Rating';
import React, { useEffect, useRef, useState } from 'react';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const bestform1099software = () => {
  const containerRef = useRef(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [removelistener, setRemovelistener] = useState(true);
  const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  const images = [
    '/assets/images/2290-steps-img.webp',
    '/assets/images/easy-steps-img.webp',
    '/assets/images/941-steps-img.webp',
    // Add more image URLs as needed
  ];
  const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  const handleScroll = (event: any) => {
    const delta = event.deltaY;
    if (delta > 0) {
      // Scroll down, show the next imag
      if (currentImageIndex < 2) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else if (delta < 0) {
      // Scroll up, show the previous image
      if (currentImageIndex > 0) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else {
      setRemovelistener(false);
    }
  };
  function useHorizontalScroll() {
    useEffect(() => {
      const el = Ref.current;
      setTempReturn(tempReturn);
      if (el) {
        const onWheel = (e: any) => {
          if (e.deltaY === 0) return;
          e.preventDefault();
          el.scrollTo({
            behavior: 'smooth',
            top: 0,
            left: 0,
          });
        };

        el.addEventListener('wheel', onWheel);
        if (removelistener === false) {
          el.addEventListener('wheel', onWheel);
        } else if (removelistener === true) {
          el.removeEventListener('wheel', onWheel);
        } else {
          el.addEventListener('wheel', onWheel);
        }
        return () => {
          el.removeEventListener('wheel', onWheel);
        };
      }
      return () => setTempReturn(false);
    }, [removelistener]);
    return Ref;
  }

  const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Best 1099 E-filing Software Providers in 2026"
          description="Compare the best 1099 software providers in 2026. Explore features, pricing, IRS compliance, bulk filing, and choose the right solution today."
          keywords=""
          canonical="comparison/best-form-1099-software/"

          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(
    180deg,
    #e9eeff 0%,
    #edfaf1 50%,
    #ffffff 100%
  )
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              Best 1099 Software for Online IRS Filing <br />
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                },
                fontWeight: 400,
                mb: 4,
                color: '#5b6472',
                lineHeight: 1.7,
                maxWidth: 950,
                mx: 'auto',
              }}
            >
              Compare leading 1099 e-file software based on pricing, supported
              forms, bulk filing, TIN Matching, W-9 collection, state filing,
              recipient delivery, integrations, and ease of use. Find the right
              solution for your business, accounting practice, or tax filing
              workflow.
            </Typography>

            <Stack
              alignItems="center"
              sx={{
                width: '100%',
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  backgroundColor: '#1e2f8f',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: 16,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#16247a',
                    transform: 'scale(1.05)',
                  },
                }}
                href="#compareoption"
              >
                Compare Your Options
              </Button>

              {/* <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontSize: 14,
                  color: '#9aa1ab',
                  fontWeight: 500,
                }}
              >
                No credit card required. Pay only when you file.
              </Typography> */}
            </Stack>
            {/* 
            <Typography
              sx={{
                mt: 0.5,
                fontSize: 11.5,
                color: '#98a2b3',
                textAlign: 'center',
              }}
            >
              Based on customer reviews
            </Typography> */}
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Top 1099 E-Filing Software Providers Compared{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Choosing the right 1099 filing software depends on your filing
                volume, business needs, and how you <br />
                prefer to file. Explore TaxZerone with other Competitors which
                find right for you.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="xl"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ px: { xs: 2, md: 3 } }}>
            <Box
              ref={containerRef}
              sx={{
                overflow: 'hidden',
                py: 2,
              }}
            >
              <Grid
                container
                spacing={2}
                sx={{
                  display: 'flex',
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  p: 2,
                  maxWidth: '1200px',
                  mx: 'auto',
                }}
              >
                {/* Card 1 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', md: '1 1 0' },
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'stretch',
                    }}
                  >
                    <Card
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: '#ffffff',
                        position: 'relative',
                        border: '1px solid #EDEDED',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pt: 4,
                          pb: 2,
                          px: 2,
                          height: 140,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/images/taxzerone-vs-1099-tax1099-img.png"
                          alt="TaxZerone vs Tax1099"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          p: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            component="h3"
                            sx={{
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#111827',
                              mb: 1.5,
                            }}
                          >
                            TaxZerone vs Tax1099
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: 13.5,
                              lineHeight: 1.6,
                              color: '#6B7280',
                              mb: 3,
                            }}
                          >
                            Best for comparing workflow depth, TIN Matching,
                            bulk imports, and integration flexibility. See how
                            each platform supports businesses that need a
                            scalable 1099 filing process without adding
                            unnecessary complexity
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href="/comparison/taxzerone-vs-tax1099"
                          fullWidth
                          sx={{
                            backgroundColor: '#333333',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1.2,
                            borderRadius: 6,
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#000000',
                            },
                          }}
                        >
                          Compare
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                </Grid>

                {/* Card 2 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', md: '1 1 0' },
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                    }}
                  >
                    <Card
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: '#ffffff',
                        position: 'relative',
                        border: '1px solid #EDEDED',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pt: 4,
                          pb: 2,
                          px: 2,
                          height: 140,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/images/taxzerone-vs-1099-track1099-avalara.png"
                          alt="taxzerone vs1099 track1099 avalara"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          p: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            component="h3"
                            sx={{
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#111827',
                              mb: 1.5,
                            }}
                          >
                            TaxZerone vs Track1099 (Avalara)
                          </Typography>

                          {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Choosing the right tax e-file provider matters.
                        </Typography> */}

                          <Typography
                            sx={{
                              fontSize: 13.5,
                              lineHeight: 1.6,
                              color: '#6B7280',
                              mb: 3,
                            }}
                          >
                            Best for evaluating high-volume filing needs and the
                            Avalara ecosystem. Compare recipient management,
                            state filing options, bulk processing, and the
                            overall fit for recurring 1099 and W-2 reporting.
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href="/comparison/taxzerone-vs-avalara-track1099"
                          fullWidth
                          sx={{
                            backgroundColor: '#333333',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1.2,
                            borderRadius: 6,
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#000000',
                            },
                          }}
                        >
                          Compare
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                </Grid>

                {/* Card 3 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', md: '1 1 0' },
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                    }}
                  >
                    <Card
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: '#ffffff',
                        position: 'relative',
                        border: '1px solid #EDEDED',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pt: 4,
                          pb: 2,
                          px: 2,
                          height: 140,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/images/taxzerone-vs-1099-tax2efile.png"
                          alt="taxzerone vs tax2efile"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          p: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            component="h3"
                            sx={{
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#111827',
                              mb: 1.5,
                            }}
                          >
                            TaxZerone vs Tax2efile
                          </Typography>

                          {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography> */}

                          <Typography
                            sx={{
                              fontSize: 13.5,
                              lineHeight: 1.6,
                              color: '#6B7280',
                              mb: 3,
                            }}
                          >
                            Best for comparing manual entry effort against a
                            more streamlined filing experience. See how both
                            providers handle form preparation, business
                            extensions, subscription requirements, and
                            scalability as filing volume grows.
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href="/comparison/taxzerone-vs-tax2efile"
                          fullWidth
                          sx={{
                            backgroundColor: '#333333',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1.2,
                            borderRadius: 6,
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#000000',
                            },
                          }}
                        >
                          Compare
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
                {/* Card 4 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', md: '1 1 0' },
                      width: '100%',
                      display: 'flex',
                      height: '100%',
                    }}
                  >
                    <Card
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: '#ffffff',
                        position: 'relative',
                        border: '1px solid #EDEDED',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pt: 4,
                          pb: 2,
                          px: 2,
                          height: 140,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/images/taxzerone-vs-1099-efile4biz-img.png"
                          alt="taxzerone vs efile4Biz"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          p: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#111827',
                              mb: 1.5,
                            }}
                          >
                            TaxZerone vs efile4Biz
                          </Typography>

                          {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography> */}

                          <Typography
                            sx={{
                              fontSize: 13.5,
                              lineHeight: 1.6,
                              color: '#6B7280',
                              mb: 3,
                            }}
                          >
                            Best for reviewing delivery costs, multi-state
                            flexibility, and filing convenience. Compare how
                            each provider manages recipient copies,
                            print-and-mail services, imports, and everyday
                            filing needs for small businesses and payroll teams.
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href="/comparison/taxzerone-vs-efile4biz"
                          fullWidth
                          sx={{
                            backgroundColor: '#333333',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1.2,
                            borderRadius: 6,
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#000000',
                            },
                          }}
                        >
                          Compare
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
                {/* Card 5 */}
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', md: '1 1 0' },
                      width: '100%',
                      display: 'flex',
                      height: '100%',
                    }}
                  >
                    <Card
                      sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        background: '#ffffff',
                        position: 'relative',
                        border: '1px solid #EDEDED',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                        '&:hover': {
                          boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pt: 4,
                          pb: 2,
                          px: 2,
                          height: 140,
                        }}
                      >
                        <Box
                          component="img"
                          src="/assets/images/taxzerone-vs-1099-1099online-img.png"
                          alt="taxzerone vs 1099Online"
                          sx={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>

                      <Box
                        sx={{
                          p: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          flexGrow: 1,
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: 700,
                              color: '#111827',
                              mb: 1.5,
                            }}
                          >
                            TaxZerone vs 1099Online
                          </Typography>

                          {/* <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography> */}

                          <Typography
                            sx={{
                              fontSize: 13.5,
                              lineHeight: 1.6,
                              color: '#6B7280',
                              mb: 3,
                            }}
                          >
                            Best for tax professionals and firms that manage
                            multiple clients or larger filing volumes. Compare
                            collaboration tools, bulk processing, integrations,
                            and workflow support for teams that need more than
                            basic online filing.
                          </Typography>
                        </Box>

                        <Button
                          variant="contained"
                          href="/comparison/taxzerone-vs-1099online"
                          fullWidth
                          sx={{
                            backgroundColor: '#333333',
                            color: '#ffffff',
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1.2,
                            borderRadius: 6,
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: '#000000',
                            },
                          }}
                        >
                          Compare
                        </Button>
                      </Box>
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#eef9fa',
          my: { xs: 0, md: 8 },
          py: { xs: 4, md: 6 },
        }}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 6 } }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={4}
            sx={{ my: { xs: 0, md: -23 } }}
          >
            {/* LEFT: TEXT */}
            <Box
              sx={{
                flex: 1,
                maxWidth: { md: 560 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,

                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  lineHeight: 1.3,
                  mb: 2,
                }}
              >
                Why Compare Form 1099 E-file Software?
              </Typography>

              <Typography
                sx={{
                  // lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                  mb: 1,
                }}
              >
                Not all Form 1099 e-file software provides the same filing
                experience. While IRS-authorized providers can electronically
                transmit returns, they differ in{' '}
                <strong style={{ fontWeight: 600 }}>
                  pricing, features, workflow, automation, support, and ease of
                  use.
                </strong>{' '}
              </Typography>
              <Typography
                sx={{
                  // lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                  mb: 1,
                }}
              >
                Comparing solutions helps businesses find the right fit for
                their needs, from{' '}
                <strong style={{ fontWeight: 600 }}>
                  bulk filing and TIN Matching to W-9 collection, state filing,
                  recipient delivery, and transparent pricing
                </strong>
                .{' '}
              </Typography>
            </Box>

            {/* RIGHT: IMAGE WITH FLOATING LABELS */}
            <Box
              sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: 240, sm: 300, md: 320 },
                mx: 'auto',
                my: { xs: 0, md: 4 },

                px: { xs: 2, sm: 0 },
              }}
            >
              <Box
                component="img"
                src="/assets/images/why-compare-form-941-e-file-software-img.webp"
                alt="TaxZerone mascot in a suit holding a briefcase"
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  position: 'relative',
                  zIndex: 1,
                }}
              />

              {/* 1. Transparent Pricing */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '7%', sm: '10%', md: '18%' },
                  left: { xs: '-5%', sm: '-12%', md: '-15%' },
                  bgcolor: '#FBE4E0',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Pricing
              </Box>

              {/* 2. Instant Email Notifications */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '38%', sm: '40%', md: '42%' },
                  right: { xs: '-8%', sm: '-20%', md: '-25%' },
                  bgcolor: '#F7D9CE',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Bulk filing
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '18%', sm: '20%', md: '22%' },
                  right: { xs: '-22%', sm: '-24%', md: '-34%' },
                  bgcolor: '#cff7ce',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Workflow
              </Box>

              {/* 3. Online Filing in Minutes */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '50%' },
                  left: { xs: '-6%', sm: '-8%', md: '-4%' },
                  bgcolor: '#E3DEF7',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Automation
              </Box>

              {/* 4. Simplify Client Approvals */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '5%', sm: '10%', md: '12%' },
                  left: { xs: '0%', sm: '5%', md: '8%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#F6D9E8',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                {' '}
                Support
              </Box>
              {/* 4. Simplify Client Approvals */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '30%', sm: '30%', md: '32%' },
                  left: { xs: '95%', sm: '95%', md: '95%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#f4f6d9',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                {' '}
                Ease of Use
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                What to Compare When Choosing 1099 Software
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="lg"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ py: { xs: 2, md: 2 } }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="stretch"
              sx={{ p: 0 }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#f8e7fb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <UploadFileIcon
                      sx={{
                        color: '#c55ad9',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    Bulk upload & Automation
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    If you file multiple forms, compare providers based on{' '}
                    <strong style={{ fontWeight: 600 }}>
                      Excel/CSV imports
                    </strong>{' '}
                    , bulk filing, and API integration to save time and reduce
                    manual entry.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff8e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <ArticleIcon
                      sx={{
                        color: '#2e7d32',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    TIN Matching
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Need to verify TINs before filing? Choose Form 1099 e-file
                    software with{' '}
                    <strong style={{ fontWeight: 600 }}> TIN Matching </strong>{' '}
                    to verify taxpayer names and Taxpayer Identification Numbers
                    (TINs) before submitting your forms.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#fff5df',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <VerifiedUserIcon
                      sx={{
                        color: '#d38c30',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    Online W-9 Collection
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Choose Form 1099 e-file software with{' '}
                    <strong style={{ fontWeight: 600 }}>
                      online W-9 collection
                    </strong>{' '}
                    to securely request, collect, and store vendor or contractor
                    information in one place
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                    mt: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dfe8ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <ContactSupportIcon
                      sx={{
                        color: '#3056d3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    State filing support
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    If you have state reporting requirements, look for{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      state filing support{' '}
                    </strong>
                    to submit your 1099 forms to participating state tax
                    agencies. Filing federal and state returns together helps
                    simplify compliance, reduce manual effort, and keep your
                    filing process organized.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                    mt: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#fffadf',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <ContentCopyIcon
                      sx={{
                        color: '#d3b230',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    Recipient Copy delivery
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Timely delivery of recipient copies is an essential part of
                    the 1099 filing process. Electronic and postal delivery
                    options can simplify distribution, reduce manual effort, and
                    help ensure recipients receive their forms by the required
                    deadline.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                    mt: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff9ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <SupportAgentIcon
                      sx={{
                        color: '#309dd3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      mb: 1.5,
                    }}
                  >
                    Security & Customer Support
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Look for{' '}
                    <strong style={{ fontWeight: 600 }}>
                      U.S.-based support and real-time status tracking
                    </strong>{' '}
                    once your return is transmitted. Staying informed throughout
                    the filing process helps ensure a smoother experience and
                    quicker resolution of any filing issues.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1100px', mx: 'auto' }}
          >
            {/* HEADING */}
            <Typography
              variant="h2"
              id="compareoption"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 28,
                  md: 34,
                  lg: 42,
                  xl: 48,
                },
                fontWeight: 600,
                textAlign: 'center',
                mb: 3,
                scrollMarginTop: 83,
              }}
            >
              Best 1099 Software Providers in 2026
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                mb: 5,
              }}
            >
              <Typography
                component="a"
                href="#taxzerone"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                TaxZerone
              </Typography>

              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#tax1099"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Tax1099
              </Typography>

              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#track1099avalara"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Track1099(Avalara)
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#tax2efile"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Tax2efile
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#efile4biz"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                efile4Biz
              </Typography>
              <Divider
                orientation="vertical"
                flexItem
                sx={{ height: '20px' }}
              />
              <Typography
                component="a"
                href="#1099online"
                sx={{
                  px: 2,
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: '#1e40af',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                1099Online
              </Typography>
            </Box>
            <Stack spacing={4}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    backgroundColor: '#213e99',
                    color: '#ffffff',
                    px: { xs: 3.5, md: 4 },
                    py: { xs: 2.5, md: 3 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      id="taxzerone"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      TaxZerone
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best Form 1099 Software for Small Businesses, CPAs & Tax
                      Professionals
                    </Typography>
                  </Box>

                  {/* <Box
                    sx={{
                      fontWeight: 600,
                      fontSize: '16px',
                      textAlign: 'right',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.8,
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Rating
                        sx={{ color: '#fac108' }}
                        value={4.4}
                        precision={0.1}
                        readOnly
                        size="medium"
                      />{' '}
                      <span>4.4 / 5</span>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.8 }}
                    >
                      as per the Trustpilot Review
                    </Typography>
                  </Box> */}
                  <Box
                    sx={{
                      backgroundColor: '#30E3B2',
                      color: '#044E3A',
                      px: 2.5,
                      py: 0.8,
                      borderRadius: '50px',
                      fontWeight: 700,
                      fontSize: '13px',
                    }}
                  >
                    Recommended
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    TaxZerone is an{' '}
                    <strong style={{ fontWeight: 600 }}>
                      IRS-authorized e-file provider for Form 1099
                    </strong>
                    , helping businesses, accountants, and tax professionals
                    prepare and electronically file 1099 returns with ease. With
                    support for multiple 1099 forms, bulk data uploads, built-in
                    validation checks, TIN Matching, online W-9 collection, and
                    a simple filing workflow, TaxZerone streamlines the entire
                    1099 filing process from data collection to IRS submission.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Affordable pay-per-form pricing starting at{' '}
                            <strong style={{ fontWeight: 600 }}>
                              $2.49 with pricing as low as $0.59 per form for
                              bulk filing
                            </strong>
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports multiple 1099 forms
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk Excel and CSV upload options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Built-in validation to reduce filing errors
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Online W-9 collection capabilities
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            TIN Matching support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Federal and participating state filing support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Secure cloud-based access
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Recipient copy delivery options
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Real-time filing status tracking
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Schedule filing
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Advanced accounting features may depend on specific
                            business requirements
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Users with complex enterprise workflows may require
                            custom integrations
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Learning all available features may take time for
                            first-time users
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Availability of certain state filing options may
                            vary
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>

                  {/* Best for & CTA Button */}
                  <Typography
                    sx={{
                      color: '#0F172A',
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    <strong>Best for:</strong> Small Businesses, CPAs, Tax
                    Professionals
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      id="tax1099"
                      sx={{
                        mt: 2,
                        px: '20px !important',
                        py: '8px !important',
                        fontSize: '18px !important',

                        transition: 'all 0.3s ease',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.05)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-1099-software`}
                    >
                      Start filing Now
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="tax1099"
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      Tax1099
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best Form 1099 Software for accountants, CPAs, and
                      businesses
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    Tax1099 supports Form 1099 filing with bulk upload
                    capabilities and tools that help businesses and tax
                    professionals manage high-volume information return
                    submissions. While the platform provides features for
                    preparing and e-filing various 1099 forms, first-time users
                    may need some time to become familiar with its interface,
                    navigation, and overall filing workflow.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports a broad range of IRS information returns,
                            including multiple Form 1099 types.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers bulk Excel/CSV uploads and API integrations.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Includes real-time and bulk TIN Matching.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Provides electronic W-9/W-8 collection.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports recipient eDelivery, print & mail, filing
                            corrections, and team workflow features.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Requires additional time for first-time users to
                            learn the filing process.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Users have reported occasional performance issues,
                            integration difficulties, and delays in customer
                            support.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="track1099avalara"
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      Track1099 (Avalara)
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best for high-volume 1099 & W-2 filers, accounting firms,
                      and businesses
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    Track1099 is a cloud-based Form 1099 e-file solution that
                    helps businesses and tax professionals prepare and submit
                    information returns electronically. The platform supports
                    various 1099 forms, bulk uploads, recipient management, IRS
                    e-filing, and state filing options to help streamline
                    recurring filing requirements. While Track1099 provides
                    essential tools for managing 1099 filings, users who are new
                    to 1099 software may need additional time to become familiar
                    with the platform’s workflow and features.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports electronic filing for multiple 1099 and W-2
                            forms.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers W-9 collection and recipient e-delivery
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports corrections and re-filing after submission
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Public documentation highlights fewer native
                            accounting integrations.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Advanced enterprise workflow and user management
                            capabilities are less prominently documented.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="tax2efile"
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      Tax2efile
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best for businesses and individuals
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    Tax2efile is an IRS-authorized e-file provider that helps
                    businesses prepare and electronically file Form 1099 returns
                    online. The platform supports several 1099 forms, federal
                    and state filing, corrections, and recipient copy delivery.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            <strong style={{ fontWeight: 600 }}>
                              User-friendly interface
                            </strong>{' '}
                            with mobile access for convenient filing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Automated error checks help identify potential
                            issues and reduce filing errors.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Real-time TIN matching and address validation help
                            verify recipient information
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Transparency pricing helps businesses and
                            individuals estimate costs without long-term
                            subscriptions or bundled plans.
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Limited integration with third-party accounting
                            tools
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="efile4biz"
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      efile4Biz
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best for businesses, accountants, and payroll providers
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    efile4Biz is an online tax filing solution that helps
                    businesses prepare and electronically file Form 1099 returns
                    with the IRS. Designed for small businesses and payroll
                    service providers, efile4Biz offers a straightforward filing
                    experience for common 1099 reporting needs.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports IRS and SSA e-filing.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers Excel, QuickBooks, and Xero imports.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports TIN Matching.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Provides recipient print & mail and electronic
                            delivery.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Cloud-based storage allows easy access to filed
                            forms year-arounds
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Reconciliation forms are not available
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Limited advanced reporting, lack of guided
                            step-by-step workflows
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    paddingTop: { xs: 2.5, md: 3 },
                    paddingLeft: { xs: 3.5, md: 4 },
                    paddingRight: { xs: 3.5, md: 4 },
                    paddingBottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      id="1099online"
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                        scrollMarginTop: 83,
                      }}
                    >
                      1099Online
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best for small-to-mid-sized businesses (SMBs), accounting
                      firms, and multi-entity filers
                    </Typography>
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    1099Online is an online Form 1099 e-file solution that helps
                    businesses prepare and submit information returns to the
                    IRS. organizations managing larger filing volumes or
                    requiring advanced automation may find its feature set more
                    limited than modern 1099 e-file solutions.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Transparent pricing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Real-time TIN matching as add-on
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Supports Bulk imports
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            It supports Combined Federal/State Filing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Offers password-protected PDF delivery by email and
                            traditional USPS mail options for recipient copies
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            customer support
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Fewer integrations
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Lacks advanced features
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Alert
                icon={
                  <InfoOutlinedIcon sx={{ color: '#475569', fontSize: 22 }} />
                }
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 2,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                <strong style={{ fontWeight: 600 }}> Disclaimer: </strong>
                The trademarks, product names, logos, and brand identities
                mentioned on this page are owned by their respective companies.
                The comparisons and information provided are compiled from
                publicly available resources and are intended for informational
                purposes only. Features, pricing, and services offered by
                providers may change periodically, and we do not guarantee that
                all details will remain current. TaxZerone has no affiliation,
                partnership, endorsement, or sponsorship relationship with the
                companies listed unless specifically stated.
              </Alert>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/which-1099-software-img.webp" />
                  <source srcSet="/assets/images/which-1099-software-img.png" />
                  <img
                    src="/assets/images/which-1099-software-img.png"
                    alt="which 1099 software"
                    className="img-responsive"
                    loading="lazy"
                    width={503}
                    height={513}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xl: 48, lg: 42, md: 34, sm: 28, xs: 24 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Which 1099 Software Is Right for You?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Every business has unique 1099 filing requirements. The best
                  software depends on your filing volume, budget, workflow
                  preferences, automation needs, and compliance requirements.
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <strong style={{ fontWeight: 600 }}> Choose </strong>
                      <Link href="/" sx={{ color: '#2020ff' }}>
                        TaxZerone
                      </Link>{' '}
                      if you want an easy-to-use 1099 filing solution with
                      transparent pricing, bulk filing, TIN Matching, online W-9
                      collection, state filing support, and a guided filing
                      experience. 
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Choose Tax1099</span>{' '}
                      if you need advanced integrations, API capabilities, and
                      comprehensive tools for managing high-volume 1099 filings.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Choose Track1099
                      </strong>{' '}
                      if you prefer a pay-per-form pricing model and
                      Subscription model with accounting software integrations
                      and recurring 1099 filing capabilities.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Choose efile4Biz{' '}
                      </span>{' '}
                      if you need a simple web-based solution for occasional
                      1099 filings and basic compliance requirements.{' '}
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Choose 1099Online{' '}
                      </span>{' '}
                      if your business has straightforward 1099 filing needs and
                      requires a basic online filing solution. 
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1">
                  Comparing{' '}
                  <strong style={{ fontWeight: 600 }}>
                    features, pricing, supported forms, automation, recipient
                    delivery options, customer support, and overall filing
                    experience
                  </strong>{' '}
                  before selecting a provider can help you find the Form 1099
                  software that best meets your business needs.{' '}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: {
                      xs: 24,
                      sm: 28,
                      md: 34,
                      lg: 42,
                      xl: 48,
                    },
                    fontWeight: 600,

                    mb: 0,
                  }}
                >
                  What Customers Say
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: 16,
                      sm: 18,
                      md: 18,
                      lg: 20,
                      xl: 22,
                    },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Discover how TaxZerone helps businesses and tax professionals
                  file with confidence.
                </Typography>
              </Box>

              <Grid container spacing={0} sx={{ mt: 0 }}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        TaxZerone has made our 1099 filing process much easier.
                        The platform is simple to use, and the built-in
                        validation gave us confidence before submitting our
                        forms.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                          textAlign: 'right',
                        }}
                      >
                        - Jorge Devila
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The phone support team was really patient and walked me
                        through everything step by step. I had no tax knowledge
                        at all going in. TaxZerone made the whole process feel
                        easy and gave me confidence. 10/10.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Elizabeth Wagner
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The bulk upload feature and real-time filing status
                        helped us streamline our year-end reporting. It has
                        become an essential part of our filing process.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                          textAlign: 'right',
                        }}
                      >
                        - Kevin Martin
                      </Typography>
                    </Paper>
                    {/* 
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Really good chat support experience. I wasn&apos;t sure
                        how to complete a few steps, but Kevin guided me clearly
                        and stayed with me until everything was done. Appreciate
                        the help.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Joseph J Perez
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Managing multiple client filings is straightforward with
                        TaxZerone. Everything we need is available in one place,
                        making tax season much less stressful.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                          textAlign: 'right',
                        }}
                      >
                        - Michael Porter
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        OMG! I cannot believe how wonderful the live support
                        was. The agent Alexia assisted me with everything I
                        needed and fixed all the issues in the most professional
                        and friendly manner. Amazing customer experience. Thank
                        You!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Luis Echenique
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: {
              xs: 24,
              sm: 28,
              md: 34,
              lg: 42,
              xl: 48,
            },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Ready to Choose Your 1099 Filing Software?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Compare providers based on your filing volume, budget, integrations,
          state filing <br />
          requirements, and recipient delivery needs.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-1099-software`}
          >
            Explore TaxZerone
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>✓ No subscription</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>✓ Pay per form</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>
              ✓ U.S.-based support
            </Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="best-1099-software-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                id="best-1099-software-faq"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                {/* Question 1 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which 1099 software is the best for small businesses?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Small businesses typically benefit from software that
                        combines affordable pricing, easy setup, automation, IRS
                        compliance, and reliable customer support. TaxZerone is
                        designed to provide these capabilities without requiring
                        subscription-based pricing.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 2 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which 1099 software is best for accountants and tax
                    professionals?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        Accountants and tax professionals should look for
                        software that supports bulk filing, client management,
                        TIN Matching, state filing, and efficient workflow
                        automation. TaxZerone provides these features to help
                        manage multiple client filings from one platform.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 3 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Is TaxZerone a better alternative to Tax1099?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box itemProp="text">
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          Both TaxZerone and Tax1099 are IRS-authorized e-file
                          providers that support Form 1099 filing. TaxZerone
                          emphasizes a simple, easy-to-navigate filing
                          experience with integrated compliance tools, while
                          Tax1099 is known for its extensive integrations and
                          API capabilities. The right choice depends on your
                          filing volume, workflow preferences, integration
                          needs, and budget.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                {/* Question 4 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      mb: 2,
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which platform is better for bulk 1099 filing: TaxZerone or
                    Tax2efile?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box itemProp="text">
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          For bulk 1099 filing, the better platform depends on
                          your business needs, filing volume, workflow
                          preferences, and required automation. Both TaxZerone
                          and Tax2efile are designed to help businesses and tax
                          professionals prepare and submit 1099 forms
                          electronically, but they differ in features, user
                          experience, and pricing approach.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default bestform1099software;
